import styled from 'styled-components';

import { Box } from 'components/Box';
import { colors, transition } from 'theme';

export const BreadCrumbs = styled(Box)`
  * {
    display: inline;
  }
`;

export const Input = styled.input`
  width: 100%;
  height: 50px;
  padding: 0 100px 0 18px;
  border-radius: 8px;
  background: ${colors.inputGrey};
  box-shadow: 0 0 0 2px ${colors.inputGrey} inset;
  appearance: none;
  border: 0;
  color: ${colors.mediumContentGrey};
  outline: 0;
  font-size: 18px;
  transition: all ${transition};
  &:focus {
    background: white;
    border: 0;
    box-shadow: 0 0 0 2px ${colors.brandBlue} inset;
  }
`;
